import { render } from "./TheLottery.vue?vue&type=template&id=e2cc3a44&scoped=true"
import script from "./TheLottery.vue?vue&type=script&lang=js"
export * from "./TheLottery.vue?vue&type=script&lang=js"

import "./TheLottery.vue?vue&type=style&index=0&id=e2cc3a44&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2cc3a44"]])

export default __exports__